<template>
<div class="comparison-left">
  <div class="comparison-left-header">
    <div  class="comparison-left-header-operation">
      <div class="dropdown-box"
        v-for="(item, index) in operationList"
        :key="index"
        @click.stop="toggleMenu(item.type)"
      >
        <img :src="item.img" />
        <span class="dropdown-name" @click="(e) => e.preventDefault()">
          {{item.title}}
        </span>
      </div>
      <div class="dropdown-box"
        v-if="parentType == 'edit'"
      >
        <img src="@/assets/version.png" />
        <span class="dropdown-name">
          版本确定
        </span>
        <div class="dropdown-ul">
          <div
            class="dropdown-li"
            v-for="(item, key) in versionList"
            :key="item"
            @click.stop="handleVersion(key)"
          >
            {{item}}
          </div>
        </div>
      </div>
      <div class="dropdown-box"
        @click.stop="changeVersion"
      >
        <img src="@/assets/diaoyue.png" />
        <span class="dropdown-name">
          版本调阅
        </span>
      </div>
    </div>
    <div class="comparison-left-header-pagination">
      <div class="btn">
        <div v-if="index > 0" @click="handlePage(`${type}Prev`)">
          <img src="../../assets/left.png" alt="">
          <span>上一页</span>
        </div>
        <div v-if="index < taskData.imgList.length - 1" @click="handlePage(`${type}Next`)">
          <span>下一页</span>
          <img src="../../assets/right.png" alt="">
        </div>
      </div>
      <div class="page">
        <span>第</span>
        <input type="text" v-model="page" @change="changeInputPage"> / {{taskData.imgList.length}}页
        <p @click="handlePageSize">跳转</p>
      </div>
      <div class="page-num">
        当前第{{index + 1}}页
      </div>
      
    </div>
  </div>
  <div class="comparison-left-title">
    <span>{{taskData.metaTitle}}</span>
    <div class="comparison-left-title-magnifying">
      <span @click="goImageBack">图片复位</span>
      <!-- <span>查看大图</span> -->
      <div>
        <img src="../../assets/shrink.png" @click="smallBtn()" alt="" />
        <img src="../../assets/magnify.png" @click="largetBtn()" alt="" />
      </div>
    </div>
  </div>
  <div class="comparison-left-content">
    <img
      v-if="index > 0"
      class="next-btn"
      src="../../assets/pre.png"
      @click="handlePage(`${type}Prev`)"
    >
    <div v-else class="next-btn"></div>
    <div class="img-box">
      <img
        :style="`position: relative;transform: scale(${picScale});`"
        :src="taskData.imgList[index].src"
        @mousedown="move"
        :ref="`pic${type}`"
      />
    </div>
    <img
      v-if="index < taskData.imgList.length - 1"
      class="next-btn"
      src="../../assets/next.png"
      @click="handlePage(`${type}Next`)"
    >
    <div v-else class="next-btn"></div>
  </div>
</div>
</template>
<script>
import metadata from '../../assets/data.png';
import catalogue from '../../assets/catalogue.png';
import { getUpdatepic } from '@/api/fileContrast'

export default {
  props: ['taskData', 'index', 'type', 'taskId', 'checkCurrentMenu', 'parentType'],
  data() {
    return {
      operationList: [
        {
          img: metadata,
          title: '元数据',
          type: 'info'
        },
        {
          img: catalogue,
          title: '查看目录',
          type: 'menu'
        },
      ],
      versionList: {
        0: '底本',
        1: '校本',
        2: '普通版本'
      },
      page: '',
      picScale: 1,
    }
  },
  methods: {
    // 版本确认
    async handleVersion(key) {
      try {
        await getUpdatepic({
          taskId: this.taskId,
          metaType: key,
          metaId: this.taskData.id
        })
        this.$message.success('保存版本成功')
        this.$emit('refreshTaskData', {
          metaType: key,
          metaId: this.taskData.id
        })
      } catch (error) {
        console.log('error', error)
      }
    },
    // 元数据和目录切换
    toggleMenu(id) {
      this.$emit('toggleMenu', {
        menuType: this.checkCurrentMenu == id ? '' : id,
        type: this.type
      })
    },
    // 上一页下一页
    handlePage(type) {
      this.$emit('handlePage', type)
    },
    // 输入页码跳转
    handlePageSize() {
      if (this.taskData.imgList.length < this.page){
        this.page = this.taskData.imgList.length
        
      } else if (this.page <= 0) {
        this.page = 1
      }

      this.$emit('handlePageSize', {
          type: this.type,
          size: this.page - 1
      })
    },
    // 版本调阅
    changeVersion() {
      this.$emit('openModal', this.type)
    },
    updated() {
      nodrageimg()
    },
    async goImageBack() {
      let odiv = this.$refs['pic' + this.type];  
      odiv.style.left = 0
      odiv.style.top = 0
      this.picScale = 1
    },
    // 图片移动
    move(e) {
      let odiv = this.$refs['pic' + this.type];        //获取目标元素

      //算出鼠标相对元素的位置
      let disX = e.clientX - odiv.offsetLeft;
      let disY = e.clientY - odiv.offsetTop;
      document.onmousemove = (e) => {       //鼠标按下并移动的事件
        //用鼠标的位置减去鼠标相对元素的位置，得到元素的位置
        let left = e.clientX - disX;
        let top = e.clientY - disY;

        //绑定元素位置到positionX和positionY上面
        this.positionX = top;
        this.positionY = left;

        //移动当前元素
        odiv.style.left = left + 'px';
        odiv.style.top = top + 'px';
      };
      document.onmouseup = (e) => {
        document.onmousemove = null;
        document.onmouseup = null;
      };
    },
    // 放大
    largetBtn() {
      if (this.picScale < 2) {
        this.picScale += 0.1
      }
    },
    // 缩小
    smallBtn() {
      if (this.picScale > 0.2) {
        this.picScale -= 0.1
      }
    },
    // 检测输入
    changeInputPage(e) {
      let numReg = /^[0-9]+$/g
      if (!numReg.test(e.target.value)) {
        this.page = ''
        return this.$message.error('请输入正确页码');
      }
    }
  }
}
</script>
<style lang="less">
.comparison-left {
  width: 50%;
  background: #fff;
  margin-right: 2px;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  &-header {
    width: 100%;
    background: #CBAB7A;
    display: flex;
    flex-wrap: wrap;

    &-operation {
      display: flex;

      .dropdown-box {
        height: 50px;
        width: 70px;
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        cursor: pointer;

        img {
          width: 14px;
          height: 14px;
          margin-right: 4px;
        }

        .dropdown-name {
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #FFFFFF;
        }

        .dropdown-ul {
          position: absolute;
          left: 0;
          top: 50px;
          background: #b69666;
          display: none;
          width: 70px;
          padding-bottom: 10px;
          z-index: 999;

          .dropdown-li {
            height: 26px;
            line-height: 26px;
            background: #b69666;
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #FFFFFF;
          }
          .dropdown-li:hover {
            background: #a48456;
          }

          .dropdown-li-checked {
            background-color: #947243;
          }
        }
      }
      
      .dropdown-box:hover .dropdown-ul {
        display: block;
      }

      .dropdown-box:hover {
        background: #B69666;
      }

    }

    &-pagination {
      flex: 1;
      padding-left: 10px;
      display: flex;
      
      .btn {
        display: flex;
        height: 100%;
        // width: 120px;
        justify-content: space-between;

        div {
          display: flex;
          width: 56px;
          height: 100%;
          justify-content: space-between;
          align-items: center;
          cursor: pointer;

          img {
            width: 14px;
            height: 14px;
          }

          span {
            font-size: 12px;
            font-weight: 400;
            color: #FFFFFF;
          }
        }
      }

      .page {
        width: 160px;
        flex: 160px 0 0;
        height: 100%;
        display: flex;
        align-items: center;
        padding-left: 10px;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #FFFFFF;
        
        span {
          margin-right: 5px;
        }
        
        input {
          width: 27px;
          height: 20px;
          background: #FEF6EA;
          border-radius: 3px;
          border: 1px solid #523D28;
          outline: none !important;
          margin-right: 5px;
          color: #000000;
          text-align: center;
        }

        p {
          width: 42px;
          height: 20px;
          background: #523D28;
          border-radius: 3px;
          display: flex;
          justify-content: center;
          align-items: center;
          margin-left: 10px;
          cursor: pointer;
        }

      }

      .page-num {
        width: 80px;
        flex: 80px 0 0;
        color: #fff;
        line-height: 50px;
      }
    }
  }

  &-title {
    width: 100%;
    height: 40px;
    background: #FEF6EA;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;

    span {
      font-size: 16px;
      line-height: 40px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #523D28;
    }

    &-magnifying {
      position: absolute;
      width: 200px;
      height: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      top: 0;
      right: 20px;
      z-index: 999;

      span {
        font-size: 14px;
        font-weight: 400;
        color: #523D28;
        &:nth-of-type(1) {
          cursor: pointer;
        }
      }

      div {
        width: 60px;
        height: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;

        img {
          width: 20px;
          height: 20px;
          cursor: pointer;
        }
      }
      
    }
  }

  &-content {
    width: 100%;
    flex: 1;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 20px;
    box-sizing: border-box;

    .next-btn {
      width: 32px;
      height: 32px;
      cursor: pointer;
    }

    .img-box {
      width: calc(100% - 90px);
      height: 678px;
      overflow: hidden;
      position: relative;

      img {
        max-width: 100%;
        max-height: 678px;
      }
    }
  }
}
</style>